var _image, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    width: 32,
    height: 32,
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.72 33.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", null, "Draw")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .pencil-cls1 {\n        fill: inherit;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Whiteboard"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "pencil-cls1",
    d: "m32.42,9.43c1.72-1.72,1.72-4.52,0-6.24l-1.9-1.9c-1.72-1.72-4.52-1.72-6.24,0l-2.3,2.3,8.14,8.14,2.3-2.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "pencil-cls1",
    x: 6.55,
    y: 13.44,
    width: 15.93,
    height: 11.51,
    transform: "translate(-9.32 15.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pencil-cls1",
    d: "m3.7,21.88l-3.7,11.84,11.84-3.7L3.7,21.88Zm-1.36,6.51l2.99,2.99-4.35,1.36,1.36-4.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "pencil-cls1",
    x: 20.51,
    y: 4.86,
    width: 5.18,
    height: 11.51,
    transform: "translate(-.74 19.44) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.5c5e028f868eda33a614ee1c69a46b18.svg";
export { ForwardRef as ReactComponent };